import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
  dialogContent: {
    paddingTop: 16,
    paddingLeft: 24,
    paddingRight: 24,
    paddingBottom: 24
  },
  appBar: {
    // borderBottom: '1px solid #8F92A1',
    padding: '24px 24px 0px 24px'
  },
  appBarHeader: {
    paddingLeft: 0
  },
  toolBar: {
    minHeight: 0
  },
  dialog: {
    '& .MuiDialog-paperScrollPaper': {
      borderRadius: 10
    },
    // zIndex: '1302!important'
  },
  dialogActions: {
    padding: 0,
    '& .MuiButtonBase-root': {
      marginBottom: 0
    }
  }
}))

export default useStyles
